import { t } from "@redotech/redo-i18n";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { settingsPagePermission } from "@redotech/redo-merchant-app-common/routing/settings-page-permission";

export const orderTrackingSettingsRoutes: PermissionedRouteObject[] = [
  {
    handle: {
      get breadcrumb() {
        return t("General", {
          context:
            "merchant settings label for general order tracking configuration",
        });
      },
      permission: settingsPagePermission("order-tracking/general"),
    },
    path: "order-tracking",
    lazy: async () => {
      const { OrderTrackingSettings } =
        await import("../../../../setting/order-tracking/order-tracking-settings");
      return { Component: OrderTrackingSettings };
    },
  },
];
